/* Weihnachtsschlitten (03.11.2026): Nach „In den Warenkorb" taucht der Weihnachtsmann mit drei Rentierpaaren am
   Kauf-Button auf und gleitet in einem ruhigen Bogen zum Warenkorb-Symbol (ca. 3,5 s). Ohne bekannten Button: Start am linken Rand.
   Zeichnung flach in Markenfarben: Weihnachtsrot, Gold, Pelzweiß; Rentiere braun, hinteres Tier je Paar heller, Leitrentier mit roter Nase.
   Geladen über snippets/gg-set-geschenk.liquid (stil 'band', also mit dem Laufband-Eintrag), endet damit von selbst nach gg_bis.
   Das Laufband kann mehrfach im HTML stehen -> window.ggSchlitten verhindert doppeltes Starten.
   Startet erst auf PUB_SUB_EVENTS.cartUpdate mit source 'product-form', also wenn das Produkt wirklich im Warenkorb liegt.
   Bewegt nur per transform/opacity, Ebene mit pointer-events:none -> blockiert keinen Klick. Bei „Bewegung reduzieren" aus. */
(function () {
  if (window.ggSchlitten) return;
  window.ggSchlitten = true;
  if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var TINTE = '#2e2a24', GOLD = '#f8c437', ROT = '#9e1f2a', PELZ = '#fffaf3', HAUT = '#f2c4a2';
  var NAH = '#6e4528', FERN = '#a27650';
  var VB_B = 256, VB_H = 74;

  // Ein Rentier im Galopp, Blick nach rechts. Körper, Hals und Kopf als eine Fläche, Beine und Geweih als runde Striche.
  var REN =
    '<path d="M3 19C3 15 8 14 14 15L30 15C33 14 35 12 37 8L39 4C40 3 42 3 43 4L47 7C48 8 48 10 46 10L42 10C40 13 38 18 35 22C33 26 28 27 22 27L12 27C6 27 3 23 3 19Z"/>' +
    '<path d="M39 4L37 0.5L41 3Z"/>' +
    '<g fill="none" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M33 24L39 29L44 30M30 25L35 31L39 34M10 25L5 30L0 30M14 26L10 32L6 35M4 18L0 15" stroke-width="2.6"/>' +
    '<path d="M40 4C39 0 37-2 34-4M38 0.5L35 0.5M36-2L34 0M42 3C43 0 45-2 47-3M44.5-1L47 0" stroke-width="1.5"/>' +
    '</g>' +
    '<path d="M31 14C33 17 35 19 36 22" fill="none" stroke="' + ROT + '" stroke-width="2"/>'; // rotes Halsband

  // Rentierpaar: das hintere etwas versetzt und heller, beide wippen leicht gegeneinander
  function paar(x, verzug, nase) {
    return '<g transform="translate(' + (x + 5) + ',15)"><g class="gg-ren" style="animation-delay:' + (verzug - 0.18) + 's" fill="' + FERN + '" stroke="' + FERN + '">' + REN + '</g></g>' +
      '<g transform="translate(' + x + ',19)"><g class="gg-ren" style="animation-delay:' + verzug + 's" fill="' + NAH + '" stroke="' + NAH + '">' + REN +
      (nase ? '<circle cx="47.5" cy="8.5" r="2.3" fill="#d62c3a" stroke="none"/>' : '') + '</g></g>';
  }

  var SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -2 ' + VB_B + ' ' + VB_H + '" width="100%" height="100%" overflow="visible">' +
    '<style>.gg-ren{animation:gg-galopp .55s ease-in-out infinite alternate}@keyframes gg-galopp{from{transform:translateY(-1.4px)}to{transform:translateY(1.4px)}}</style>' +
    // Zügel: von der Hand des Weihnachtsmanns durch alle drei Paare
    '<path d="M68 26C84 34 94 38 106 37L250 35" fill="none" stroke="' + GOLD + '" stroke-width="1.3"/>' +
    paar(100, 0, false) + paar(150, -0.2, false) + paar(200, -0.4, true) +
    // Geschenksack, gold mit roter Schnur
    '<path d="M10 41C8 29 12 19 20 17C28 19 31 29 29 41Z" fill="' + GOLD + '"/>' +
    '<path d="M16 19Q20 22 24 19" fill="none" stroke="' + ROT + '" stroke-width="1.8" stroke-linecap="round"/>' +
    // Weihnachtsmann: Mantel, Gürtel mit Schnalle, Arm mit Pelzmanschette und Handschuh
    '<path d="M24 42C24 29 30 23 41 23C52 23 58 29 58 42Z" fill="' + ROT + '"/>' +
    '<rect x="24.5" y="34" width="33" height="3.6" fill="' + TINTE + '"/><rect x="44" y="33.2" width="5" height="5.2" rx="1" fill="none" stroke="' + GOLD + '" stroke-width="1.3"/>' +
    '<path d="M47 29L63 27" stroke="' + ROT + '" stroke-width="6" stroke-linecap="round"/>' +
    '<circle cx="62.5" cy="27" r="3.4" fill="' + PELZ + '"/><circle cx="67" cy="26.6" r="2.9" fill="' + TINTE + '"/>' +
    // Kopf: Gesicht, Nase, Auge, Bart mit Schnurrbart, Mütze mit Pelzrand und Bommel, die nach hinten weht
    '<circle cx="42" cy="16" r="6" fill="' + HAUT + '"/>' +
    '<path d="M35 16C35 27 40 31 44 31C49 31 51.5 25 50 17.5C48 20.5 45 21 42.5 20.5C39.5 20 37 18.5 35 16Z" fill="' + PELZ + '"/>' +
    '<path d="M42 19.5C44 18 47 18 49 19.5C47 21.5 44 21.5 42 19.5Z" fill="' + PELZ + '"/>' +
    '<circle cx="48.3" cy="16.3" r="1.7" fill="#e3a07a"/><circle cx="45.6" cy="13.8" r="0.9" fill="' + TINTE + '"/>' +
    '<path d="M35 11C34 5 39 1 45 2C50 3 51 7 50 11Z" fill="' + ROT + '"/>' +
    '<path d="M36 6C32 6 28 9 27 13" fill="none" stroke="' + ROT + '" stroke-width="4.5" stroke-linecap="round"/>' +
    '<circle cx="26.5" cy="14" r="3.1" fill="' + PELZ + '"/>' +
    '<rect x="33.5" y="9.5" width="18" height="4.6" rx="2.3" fill="' + PELZ + '"/>' +
    // Schlitten: Rückenlehne, Sitzkante, eingerollter Bug, goldene Zierlinie
    '<path d="M6 26Q6 20 12 20Q17 20 17 26L17 41L63 41Q69 41 73 33Q77 25 83 26Q88 27.5 86.5 32.5Q85 36.5 80.5 35Q78 43 72 51Q66 59 54 59L20 59Q6 59 6 47Z" fill="' + ROT + '"/>' +
    '<path d="M10 49Q12 54 21 54L54 54Q63 54 68.5 47" fill="none" stroke="' + GOLD + '" stroke-width="1.6" stroke-linecap="round"/>' +
    '<circle cx="11.5" cy="25" r="2" fill="' + GOLD + '"/><circle cx="82.5" cy="30.5" r="2" fill="' + GOLD + '"/>' +
    // goldene Kufe mit Streben und vorne hochgebogener Spitze
    '<path d="M2 69L74 69Q86 69 88 59Q89 53 84 52.5M22 59L22 69M56 59L56 69" fill="none" stroke="' + GOLD + '" stroke-width="2.6" stroke-linecap="round"/>' +
    '</svg>';

  var startPunkt = null;

  // Position des Kauf-Buttons beim Klick merken; geflogen wird erst, wenn das Produkt im Warenkorb liegt
  document.addEventListener('submit', function (e) {
    var pf = e.target && e.target.closest ? e.target.closest('product-form') : null;
    if (!pf) return;
    var btn = pf.querySelector('[type="submit"]') || e.target;
    var r = btn.getBoundingClientRect();
    startPunkt = { x: r.left + r.width / 2, y: r.top + r.height / 2 };
  }, true);

  function zielElement() {
    return document.getElementById('cart-icon-bubble');
  }

  function zielPunkt(el) {
    if (el) {
      var r = el.getBoundingClientRect();
      if (r.width && r.bottom > 0) return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
    }
    return { x: window.innerWidth - 32, y: 28 }; // Kopfzeile weggescrollt: in die Ecke oben rechts
  }

  function funke(x, y) {
    var s = document.createElement('span');
    var g = 2.5 + Math.random() * 3.5;
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText = 'position:fixed;left:0;top:0;width:' + g + 'px;height:' + g + 'px;border-radius:50%;pointer-events:none;z-index:1000;' +
      'background:' + (Math.random() < 0.75 ? GOLD : '#fff') + ';box-shadow:0 0 6px ' + GOLD + ';';
    document.body.appendChild(s);
    var dx = -6 - Math.random() * 14, dy = 10 + Math.random() * 22;
    var a = s.animate([
      { transform: 'translate(' + x + 'px,' + y + 'px) scale(1)', opacity: 1 },
      { transform: 'translate(' + (x + dx) + 'px,' + (y + dy) + 'px) scale(0)', opacity: 0 }
    ], { duration: 900 + Math.random() * 500, easing: 'ease-out' });
    a.onfinish = function () { s.remove(); };
    setTimeout(function () { s.remove(); }, 1600); // im Hintergrund-Tab läuft die Animation nicht zu Ende
  }

  function fliegen(von) {
    var zielEl = zielElement();
    var breite = Math.min(230, window.innerWidth * 0.55);
    var hoehe = breite * VB_H / VB_B;
    var x0 = von ? von.x : -breite / 2, y0 = von ? von.y : window.innerHeight * 0.45;

    var el = document.createElement('div');
    el.setAttribute('aria-hidden', 'true');
    el.style.cssText = 'position:fixed;left:0;top:0;width:' + breite + 'px;height:' + hoehe + 'px;pointer-events:none;z-index:1001;will-change:transform,opacity;';
    el.innerHTML = SVG;
    document.body.appendChild(el);

    var dauer = 3500, t0 = null, letzterFunke = 0;
    // Weg: ein ruhiger Bogen ohne Auf und Ab (Wunsch 03.11.). Erst nach rechts, dann sanft hinauf ins Ziel.
    // Quadratische Kurve, der Kontrollpunkt liegt auf Starthöhe, 70 % des Wegs nach rechts.
    function punkt(t, nach) {
      var kx = x0 + (nach.x - x0) * 0.7, u = 1 - t;
      return { x: u * u * x0 + 2 * u * t * kx + t * t * nach.x, y: u * u * y0 + 2 * u * t * y0 + t * t * nach.y };
    }
    function schritt(jetzt) {
      if (t0 === null) t0 = jetzt;
      // Ziel jedes Bild neu messen: am Handy schiebt das Warenkorb-Popup die Kopfzeile erst während des Flugs ins Bild
      var nach = zielPunkt(zielEl);
      var roh = Math.min((jetzt - t0) / dauer, 1);
      var t = 0.5 - Math.cos(roh * Math.PI) / 2; // sanft anfahren und sanft ankommen
      var p = punkt(t, nach), q = punkt(Math.min(t + 0.01, 1), nach);
      var winkel = Math.max(-18, Math.min(10, Math.atan2(q.y - p.y, q.x - p.x) * 180 / Math.PI || 0));
      // wächst am Button aus klein heraus, schrumpft am Ende ins Warenkorb-Symbol
      var groesse = von && roh < 0.12 ? 0.3 + 0.7 * (roh / 0.12) : 1 - 0.75 * Math.max(0, (roh - 0.8) / 0.2);
      el.style.transform = 'translate(' + (p.x - breite / 2) + 'px,' + (p.y - hoehe / 2) + 'px) rotate(' + winkel + 'deg) scale(' + groesse + ')';
      el.style.opacity = roh > 0.9 ? String((1 - roh) / 0.1) : (von && roh < 0.06 ? String(roh / 0.06) : '1');
      if (jetzt - letzterFunke > 55 && roh > 0.04 && roh < 0.9) {
        letzterFunke = jetzt;
        funke(p.x - breite * 0.45 * groesse, p.y + hoehe * 0.35 * groesse);
      }
      if (roh < 1) {
        requestAnimationFrame(schritt);
      } else {
        el.remove();
        if (zielEl && zielEl.animate) {
          zielEl.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'ease-out' });
        }
      }
    }
    requestAnimationFrame(schritt);
  }

  // Zum Testen in der Konsole: ggSchlitten.fliegen() startet einen Flug ohne Warenkorb (vom linken Rand),
  // ggSchlitten.fliegen({ x: 200, y: 400 }) von einem Punkt aus
  window.ggSchlitten = { fliegen: fliegen, svg: SVG };

  function anmelden() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
      if (!ev || ev.source !== 'product-form') return;
      var von = startPunkt;
      startPunkt = null;
      fliegen(von);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', anmelden);
  } else {
    anmelden();
  }
})();
